import { useSetAtom } from "jotai";

import { notificationsPanelOpenAtom } from "./notifications-panel.state";

export const useNotificationsPanel = () => {
  const setOpen = useSetAtom(notificationsPanelOpenAtom);

  const openPanel = () => setOpen(true);
  const closePanel = () => setOpen(false);

  return {
    openPanel,
    closePanel,
  };
};
